import React from "react";
const Overlays = ({ children }) => {
  return <div>{children}</div>;
};
export default Overlays;
